module.exports = "<div class=\"profile-card__text_lh24\">{{ count() }}</div>\n"